import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Users } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import Utils from '../../../../angularJs/src/app/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  private http = inject(HttpClient);
  private Utils = inject(Utils);

  private env = inject<PIMSEnvironment>(ENVIRONMENT);

  createNewUser(newUser: Users.User) {
    const payload = { ...newUser };

    Object.assign(payload, {
      terms: true,
      dob: this.Utils.encodeISODate(new Date(payload.dob)),
      app: {
        platform: 'PIMS',
        version: '1',
      },
    });
    return this.http.post(`${this.env.constants.ADMIN_API_URL}/admin/users`, payload);
  }
}
